(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-tabs"] && !Shopify.designMode) return;
  try {
    
  function initTabs(container) {
      const tabs = container.querySelectorAll('[role="tab"]');
      const panel = container.querySelector('[role="tabpanel"]');
      const contentScript = container.querySelector('[data-tabs-content]');
      
      if (!tabs.length || !panel || !contentScript) return;
      
      let contentData;
      try {
        contentData = JSON.parse(contentScript.textContent);
      } catch(e) {
        console.error('Erro ao parsear dados das tabs:', e);
        return;
      }
      
      const textColumn = panel.querySelector('.content-tabs-text');
      const mediaColumn = panel.querySelector('.content-tabs-media');
      
      if (!textColumn || !mediaColumn) return;
      
      function updateContent(blockId) {
        const blockData = contentData.find(b => b.id === blockId);
        if (!blockData) {
          console.warn('Block data não encontrado para ID:', blockId);
          return;
        }
        
        // Elementos de texto
        const titleEl = textColumn.querySelector('[data-content="title"]');
        const subtitleEl = textColumn.querySelector('[data-content="subtitle"]');
        const descEl = textColumn.querySelector('[data-content="description"]');
        const existingWrapper = mediaColumn.querySelector('.content-tabs-media-wrapper');
        
        // Fase 1: Fade out dos elementos atuais
        if (titleEl) titleEl.classList.add('fade-out');
        if (subtitleEl) subtitleEl.classList.add('fade-out');
        if (descEl) descEl.classList.add('fade-out');
        if (existingWrapper) existingWrapper.classList.add('fade-out');
        
        // Fase 2: Após fade out, atualiza conteúdo e faz fade in
        setTimeout(function() {
          // Atualiza título
          if (titleEl) {
            titleEl.textContent = blockData.title || '';
            titleEl.style.display = blockData.title ? '' : 'none';
            titleEl.classList.remove('fade-out');
            titleEl.classList.add('fade-in');
            setTimeout(function() {
              titleEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza subtítulo
          if (subtitleEl) {
            subtitleEl.textContent = blockData.subtitle || '';
            subtitleEl.style.display = blockData.subtitle ? '' : 'none';
            subtitleEl.classList.remove('fade-out');
            subtitleEl.classList.add('fade-in');
            setTimeout(function() {
              subtitleEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza descrição
          if (descEl) {
            descEl.innerHTML = blockData.description || '';
            descEl.style.display = blockData.description ? '' : 'none';
            descEl.classList.remove('fade-out');
            descEl.classList.add('fade-in');
            setTimeout(function() {
              descEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza mídia
          const existingClasses = existingWrapper ? Array.from(existingWrapper.classList) : [];
          const existingBorderRadius = existingWrapper ? existingWrapper.style.borderRadius : '';
          
          if (existingWrapper) {
            existingWrapper.remove();
          }
          
          if (blockData.media_type === 'image' && blockData.media_image) {
            const imgWrapper = document.createElement('div');
            imgWrapper.className = 'content-tabs-media-wrapper fade-in';
            existingClasses.forEach(cls => {
              if (cls.startsWith('content-tabs-media--desktop-') || cls.startsWith('content-tabs-media--mobile-')) {
                imgWrapper.classList.add(cls);
              }
            });
            if (existingBorderRadius) {
              imgWrapper.style.borderRadius = existingBorderRadius;
            }
            
            const img = document.createElement('img');
            img.src = blockData.media_image;
            img.alt = blockData.media_alt || blockData.title || '';
            img.className = 'content-tabs-image';
            img.loading = 'lazy';
            
            imgWrapper.appendChild(img);
            mediaColumn.appendChild(imgWrapper);
            
            setTimeout(function() {
              imgWrapper.classList.remove('fade-in');
            }, 400);
          } else if (blockData.media_type === 'video' && blockData.media_video && blockData.media_video.mp4) {
            const videoWrapper = document.createElement('div');
            videoWrapper.className = 'content-tabs-media-wrapper fade-in';
            existingClasses.forEach(cls => {
              if (cls.startsWith('content-tabs-media--desktop-') || cls.startsWith('content-tabs-media--mobile-')) {
                videoWrapper.classList.add(cls);
              }
            });
            if (existingBorderRadius) {
              videoWrapper.style.borderRadius = existingBorderRadius;
            }
            
            const video = document.createElement('video');
            video.className = 'content-tabs-video';
            video.playsInline = true;
            if (blockData.media_video.preview) {
              video.poster = blockData.media_video.preview;
            }
            
            const source = document.createElement('source');
            source.src = blockData.media_video.mp4;
            source.type = blockData.media_video.mime_type || 'video/mp4';
            video.appendChild(source);
            
            videoWrapper.appendChild(video);
            mediaColumn.appendChild(videoWrapper);
            
            setTimeout(function() {
              videoWrapper.classList.remove('fade-in');
            }, 400);
          } else {
            // Imagem de exemplo quando a aba não tem mídia inserida
            const placeholderTemplate = container.querySelector('.content-tabs-media-placeholder-template');
            if (placeholderTemplate && placeholderTemplate.content) {
              const placeholderClone = placeholderTemplate.content.cloneNode(true);
              const wrapper = placeholderClone.querySelector('.content-tabs-media-wrapper');
              if (wrapper) {
                wrapper.classList.add('fade-in');
                if (existingBorderRadius) {
                  wrapper.style.borderRadius = existingBorderRadius;
                }
                mediaColumn.appendChild(placeholderClone);
                setTimeout(function() {
                  wrapper.classList.remove('fade-in');
                }, 400);
              }
            }
          }
        }, 300); // Aguarda fade out completar
      }
      
      tabs.forEach(function(tab) {
        tab.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const clickedTab = this;
          const blockId = clickedTab.getAttribute('data-tab');
          
          // Atualiza tabs
          tabs.forEach(function(t) {
            if (t === clickedTab) {
              t.classList.add('active');
              t.setAttribute('aria-selected', 'true');
            } else {
              t.classList.remove('active');
              t.setAttribute('aria-selected', 'false');
            }
          });
          
          // Atualiza conteúdo
          updateContent(blockId);
        };
      });
      
      // Setas do carrossel
      const arrows = container.querySelectorAll('.content-tabs-carousel-arrow');
      arrows.forEach(function(arrow) {
        arrow.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const isPrev = this.classList.contains('content-tabs-carousel-arrow--prev');
          const activeTab = container.querySelector('[role="tab"].active');
          if (!activeTab) return;
          
          const allTabs = Array.from(tabs);
          const currentIndex = allTabs.indexOf(activeTab);
          let targetTab;
          
          if (isPrev) {
            targetTab = currentIndex > 0 ? allTabs[currentIndex - 1] : allTabs[allTabs.length - 1];
          } else {
            targetTab = currentIndex < allTabs.length - 1 ? allTabs[currentIndex + 1] : allTabs[0];
          }
          
          if (targetTab) {
            targetTab.onclick(e);
          }
        };
      });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    // Inicializar todas as seções
    document.querySelectorAll('[data-section-id]').forEach(initTabs);
  });
  
  // Reinitialize on section reload (Shopify theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const container = event.target.querySelector('[data-section-id]');
      if (container) {
        initTabs(container);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"]) return;
  try {
    
  const htmlEl = document.documentElement;
  let lockedScrollY = 0;
  const header2SchemeHold = new WeakMap();

  const parseCssTimeMs = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return 0;

    const n = parseFloat(raw);
    if (Number.isNaN(n)) return 0;
    if (raw.endsWith('ms')) return n;
    if (raw.endsWith('s')) return n * 1000;

    return n;
  };

  const prefersHeader2ReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getHeader2SchemeHoldMs = (root, kind) => {
    if (prefersHeader2ReducedMotion()) return 0;

    const styles = getComputedStyle(root);
    const megaClose = parseCssTimeMs(styles.getPropertyValue('--header-2-mega-close-duration'));
    const dialog = parseCssTimeMs(styles.getPropertyValue('--dialog-opening-speed'));

    if (kind === 'mobile') return Math.max(dialog, 280);

    return Math.max(megaClose, 280);
  };

  const clearHeader2SchemeHold = (root) => {
    const pending = header2SchemeHold.get(root);
    if (pending) clearTimeout(pending);
    header2SchemeHold.delete(root);
  };

  const applyHeader2Scheme = (root, useTransparent) => {
    const base = root.getAttribute('data-scheme-base');
    const trans = root.getAttribute('data-scheme-transparent');

    if (base && trans && base !== trans) {
      root.classList.toggle(trans, useTransparent);
      root.classList.toggle(base, !useTransparent);
    }

    root.classList.toggle('header-2--transparent', useTransparent);
  };

  const syncHeader2Scheme = () => {
    const roots = document.querySelectorAll('[data-header-2][data-header-2-transparent="true"]');
    if (!roots.length) return;

    const atTop = window.scrollY <= 8;

    for (const root of roots) {
      const megaOpen =
        root.matches(':has(.header-2__nav-item--has-mega:hover)') ||
        root.matches(':has(.header-2__nav-item--has-mega:focus-within)');
      const mobileOpen = root.classList.contains('is-menu-open');
      const menuOpen = megaOpen || mobileOpen;

      if (menuOpen) {
        clearHeader2SchemeHold(root);
        root.dataset.header2SchemeHold = '1';
        root.dataset.header2MenuKind = mobileOpen ? 'mobile' : 'mega';
        applyHeader2Scheme(root, false);
        continue;
      }

      if (!atTop) {
        clearHeader2SchemeHold(root);
        root.dataset.header2SchemeHold = '';
        applyHeader2Scheme(root, false);
        continue;
      }

      if (root.dataset.header2SchemeHold === '1') {
        if (!header2SchemeHold.has(root)) {
          const delay = getHeader2SchemeHoldMs(root, root.dataset.header2MenuKind);
          const timer = setTimeout(() => {
            header2SchemeHold.delete(root);
            root.dataset.header2SchemeHold = '';
            syncHeader2Scheme();
          }, delay);

          header2SchemeHold.set(root, timer);
        }

        applyHeader2Scheme(root, false);
        continue;
      }

      applyHeader2Scheme(root, true);
    }
  };

  const activatePane = (root, paneId) => {
    if (!root) return;

    const target = root.querySelector(`[data-pane="${paneId}"]`);
    if (!target) return;

    for (const pane of root.querySelectorAll('[data-pane]')) {
      pane.classList.remove('is-active', 'is-behind');
    }

    target.classList.add('is-active');

    let current = target;
    while (current && current.dataset.pane !== 'root') {
      const parentId = current.getAttribute('data-pane-parent') || 'root';
      const parent = root.querySelector(`[data-pane="${parentId}"]`);
      if (!parent) break;
      parent.classList.add('is-behind');
      current = parent;
    }

    root.classList.toggle('is-submenu-open', paneId !== 'root');
  };

  const resetSubmenu = (root) => {
    if (!root) return;

    activatePane(root, 'root');

    for (const submenu of root.querySelectorAll('[data-header-2-submenu].is-open')) {
      submenu.classList.remove('is-open');
      const toggle = submenu.querySelector('[data-header-2-accordion-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  };

  const syncMenuOffset = (root) => {
    if (!root) return;

    const bar = root.querySelector('.header-2__bar');
    if (!bar) return;

    const top = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    root.style.setProperty('--header-2-menu-top', `${top}px`);
  };

  const syncAllHeader2Offsets = () => {
    for (const root of document.querySelectorAll('[data-header-2]')) {
      syncMenuOffset(root);
    }
  };

  const setMenuOpen = (root, open) => {
    if (!root) return;
    const panel = root.querySelector('[data-header-2-menu-panel]');
    const toggles = root.querySelectorAll('[data-header-2-menu-toggle]');
    const section = root.closest('.header-2-section');

    root.classList.toggle('is-menu-open', open);

    for (const button of toggles) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (panel) {
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    if (open) {
      root.classList.remove('is-header-hidden');
      root.classList.add('is-sticky-active');

      const pinTop = section ? Math.max(0, Math.round(section.getBoundingClientRect().top)) : 0;
      lockedScrollY = window.scrollY;

      if (section && lockedScrollY > 8) {
        section.style.setProperty('--header-2-pin-top', `${pinTop}px`);
        section.classList.add('is-menu-pinned');
      }

      htmlEl.classList.add('header-2-menu-open');
      document.body.style.top = `-${lockedScrollY}px`;
      syncMenuOffset(root);
      requestAnimationFrame(() => {
        syncMenuOffset(root);
        syncHeader2Scheme();
      });
    } else {
      const y = lockedScrollY;

      htmlEl.classList.add('header-2-restoring-scroll');
      htmlEl.classList.remove('header-2-menu-open');
      document.body.style.top = '';
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });

      if (section) {
        section.classList.remove('is-menu-pinned');
        section.style.removeProperty('--header-2-pin-top');
      }

      requestAnimationFrame(() => {
        htmlEl.classList.remove('header-2-restoring-scroll');
        syncHeader2Scheme();
      });

      resetSubmenu(root);
    }
  };

  document.addEventListener('click', (event) => {
    const menuToggle = event.target.closest('[data-header-2-menu-toggle]');
    if (menuToggle) {
      const root = menuToggle.closest('[data-header-2]');
      setMenuOpen(root, !root.classList.contains('is-menu-open'));
      return;
    }

    const backdrop = event.target.closest('[data-header-2-backdrop]');
    if (backdrop) {
      setMenuOpen(backdrop.closest('[data-header-2]'), false);
      return;
    }

    const accordionToggle = event.target.closest('[data-header-2-accordion-toggle]');
    if (accordionToggle) {
      const submenu = accordionToggle.closest('[data-header-2-submenu]');
      if (!submenu) return;

      const listItem = submenu.closest('li');
      const parentList = listItem ? listItem.parentElement : null;

      if (parentList) {
        for (const sibling of parentList.children) {
          const other = sibling.querySelector(':scope > [data-header-2-submenu]');
          if (!other || other === submenu || !other.classList.contains('is-open')) continue;

          other.classList.remove('is-open');
          for (const nested of other.querySelectorAll('[data-header-2-submenu].is-open')) {
            nested.classList.remove('is-open');
          }
          for (const button of other.querySelectorAll('[data-header-2-accordion-toggle]')) {
            button.setAttribute('aria-expanded', 'false');
          }
        }
      }

      const expanded = accordionToggle.getAttribute('aria-expanded') === 'true';
      submenu.classList.toggle('is-open', !expanded);
      accordionToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');

      if (expanded) {
        for (const nested of submenu.querySelectorAll('[data-header-2-submenu].is-open')) {
          nested.classList.remove('is-open');
        }
        for (const button of submenu.querySelectorAll('[data-header-2-accordion-toggle]')) {
          button.setAttribute('aria-expanded', 'false');
        }
      }

      return;
    }

    const openSubmenu = event.target.closest('[data-header-2-submenu-open]');
    if (openSubmenu) {
      const root = openSubmenu.closest('[data-header-2]');
      const targetId = openSubmenu.getAttribute('data-pane-target');
      if (root && targetId) activatePane(root, targetId);
      return;
    }

    const back = event.target.closest('[data-header-2-submenu-back]');
    if (back) {
      const pane = back.closest('[data-pane]');
      const root = back.closest('[data-header-2]');
      const parentId = pane ? pane.getAttribute('data-pane-parent') || 'root' : 'root';
      activatePane(root, parentId);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    for (const root of document.querySelectorAll('[data-header-2].is-menu-open')) {
      setMenuOpen(root, false);
    }
  });

  const initHeader2Sticky = () => {
    const roots = document.querySelectorAll('[data-header-2][data-header-2-sticky="scroll-up"]');
    if (!roots.length) return;

    let lastScrollY = window.scrollY;
    let ticking = false;
    let upwardPx = 0;

    const revealThreshold = () => Math.max(24, Math.round(window.innerHeight * 0.05));

    const updateSticky = () => {
      ticking = false;

      if (htmlEl.classList.contains('header-2-menu-open')) return;

      const scrollY = Math.max(0, window.scrollY);
      const delta = lastScrollY - scrollY;
      lastScrollY = scrollY;

      for (const root of roots) {
        if (root.classList.contains('is-menu-open')) {
          root.classList.add('is-sticky-active');
          root.classList.remove('is-header-hidden');
          upwardPx = 0;
          continue;
        }

        if (scrollY <= 8) {
          root.classList.remove('is-sticky-active', 'is-header-hidden');
          upwardPx = 0;
          continue;
        }

        if (delta > 0) {
          if (root.classList.contains('is-header-hidden')) {
            upwardPx += delta;

            if (upwardPx >= revealThreshold()) {
              root.classList.add('is-sticky-active');
              root.classList.remove('is-header-hidden');
              upwardPx = 0;
            }
          } else {
            root.classList.add('is-sticky-active');
            root.classList.remove('is-header-hidden');
            upwardPx = 0;
          }
        } else if (delta < 0) {
          root.classList.add('is-header-hidden');
          upwardPx = 0;
        }
      }
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateSticky);
        }
      },
      { passive: true }
    );
  };

  initHeader2Sticky();
  syncAllHeader2Offsets();
  syncHeader2Scheme();

  const initHeader2KanCards = () => {
    const wraps = document.querySelectorAll('.header-2-kan__cards-wrap');

    for (const wrap of wraps) {
      if (wrap.dataset.header2KanBound === 'true') continue;

      const scroller = wrap.querySelector('[data-header-2-kan-scroller]');
      const prev = wrap.querySelector('[data-header-2-kan-prev]');
      const next = wrap.querySelector('[data-header-2-kan-next]');
      if (!scroller || !prev || !next) continue;

      wrap.dataset.header2KanBound = 'true';

      const updateNav = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const canScroll = maxScroll > 4;
        prev.hidden = !canScroll || scroller.scrollLeft <= 4;
        next.hidden = !canScroll || scroller.scrollLeft >= maxScroll - 4;
      };

      const scrollByCard = (direction) => {
        const card = scroller.querySelector('.header-2-kan__card');
        const styles = getComputedStyle(scroller);
        const gap = parseFloat(styles.columnGap || styles.gap) || 12;
        const amount = ((card && card.getBoundingClientRect().width) || scroller.clientWidth / 3) + gap;
        scroller.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      prev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollByCard(-1);
      });
      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollByCard(1);
      });
      scroller.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }
  };

  initHeader2KanCards();

  window.addEventListener(
    'scroll',
    () => {
      requestAnimationFrame(syncHeader2Scheme);
    },
    { passive: true }
  );

  for (const root of document.querySelectorAll('[data-header-2][data-header-2-transparent="true"]')) {
    root.addEventListener('mouseover', syncHeader2Scheme);
    root.addEventListener('mouseout', syncHeader2Scheme);
    root.addEventListener('focusin', syncHeader2Scheme);
    root.addEventListener('focusout', syncHeader2Scheme);
  }

  window.addEventListener('resize', syncAllHeader2Offsets, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncAllHeader2Offsets, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const htmlEl = document.documentElement;
  let lockedScrollY = 0;
  const header2SchemeHold = new WeakMap();

  const parseCssTimeMs = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return 0;

    const n = parseFloat(raw);
    if (Number.isNaN(n)) return 0;
    if (raw.endsWith('ms')) return n;
    if (raw.endsWith('s')) return n * 1000;

    return n;
  };

  const prefersHeader2ReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getHeader2SchemeHoldMs = (root, kind) => {
    if (prefersHeader2ReducedMotion()) return 0;

    const styles = getComputedStyle(root);
    const megaClose = parseCssTimeMs(styles.getPropertyValue('--header-2-mega-close-duration'));
    const dialog = parseCssTimeMs(styles.getPropertyValue('--dialog-opening-speed'));

    if (kind === 'mobile') return Math.max(dialog, 280);

    return Math.max(megaClose, 280);
  };

  const clearHeader2SchemeHold = (root) => {
    const pending = header2SchemeHold.get(root);
    if (pending) clearTimeout(pending);
    header2SchemeHold.delete(root);
  };

  const applyHeader2Scheme = (root, useTransparent) => {
    const base = root.getAttribute('data-scheme-base');
    const trans = root.getAttribute('data-scheme-transparent');

    if (base && trans && base !== trans) {
      root.classList.toggle(trans, useTransparent);
      root.classList.toggle(base, !useTransparent);
    }

    root.classList.toggle('header-2--transparent', useTransparent);
  };

  const syncHeader2Scheme = () => {
    const roots = document.querySelectorAll('[data-header-2][data-header-2-transparent="true"]');
    if (!roots.length) return;

    const atTop = window.scrollY <= 8;

    for (const root of roots) {
      const megaOpen =
        root.matches(':has(.header-2__nav-item--has-mega:hover)') ||
        root.matches(':has(.header-2__nav-item--has-mega:focus-within)');
      const mobileOpen = root.classList.contains('is-menu-open');
      const menuOpen = megaOpen || mobileOpen;

      if (menuOpen) {
        clearHeader2SchemeHold(root);
        root.dataset.header2SchemeHold = '1';
        root.dataset.header2MenuKind = mobileOpen ? 'mobile' : 'mega';
        applyHeader2Scheme(root, false);
        continue;
      }

      if (!atTop) {
        clearHeader2SchemeHold(root);
        root.dataset.header2SchemeHold = '';
        applyHeader2Scheme(root, false);
        continue;
      }

      if (root.dataset.header2SchemeHold === '1') {
        if (!header2SchemeHold.has(root)) {
          const delay = getHeader2SchemeHoldMs(root, root.dataset.header2MenuKind);
          const timer = setTimeout(() => {
            header2SchemeHold.delete(root);
            root.dataset.header2SchemeHold = '';
            syncHeader2Scheme();
          }, delay);

          header2SchemeHold.set(root, timer);
        }

        applyHeader2Scheme(root, false);
        continue;
      }

      applyHeader2Scheme(root, true);
    }
  };

  const activatePane = (root, paneId) => {
    if (!root) return;

    const target = root.querySelector(`[data-pane="${paneId}"]`);
    if (!target) return;

    for (const pane of root.querySelectorAll('[data-pane]')) {
      pane.classList.remove('is-active', 'is-behind');
    }

    target.classList.add('is-active');

    let current = target;
    while (current && current.dataset.pane !== 'root') {
      const parentId = current.getAttribute('data-pane-parent') || 'root';
      const parent = root.querySelector(`[data-pane="${parentId}"]`);
      if (!parent) break;
      parent.classList.add('is-behind');
      current = parent;
    }

    root.classList.toggle('is-submenu-open', paneId !== 'root');
  };

  const resetSubmenu = (root) => {
    if (!root) return;

    activatePane(root, 'root');

    for (const submenu of root.querySelectorAll('[data-header-2-submenu].is-open')) {
      submenu.classList.remove('is-open');
      const toggle = submenu.querySelector('[data-header-2-accordion-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  };

  const syncMenuOffset = (root) => {
    if (!root) return;

    const bar = root.querySelector('.header-2__bar');
    if (!bar) return;

    const top = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    root.style.setProperty('--header-2-menu-top', `${top}px`);
  };

  const syncAllHeader2Offsets = () => {
    for (const root of document.querySelectorAll('[data-header-2]')) {
      syncMenuOffset(root);
    }
  };

  const setMenuOpen = (root, open) => {
    if (!root) return;
    const panel = root.querySelector('[data-header-2-menu-panel]');
    const toggles = root.querySelectorAll('[data-header-2-menu-toggle]');
    const section = root.closest('.header-2-section');

    root.classList.toggle('is-menu-open', open);

    for (const button of toggles) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (panel) {
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    if (open) {
      root.classList.remove('is-header-hidden');
      root.classList.add('is-sticky-active');

      const pinTop = section ? Math.max(0, Math.round(section.getBoundingClientRect().top)) : 0;
      lockedScrollY = window.scrollY;

      if (section && lockedScrollY > 8) {
        section.style.setProperty('--header-2-pin-top', `${pinTop}px`);
        section.classList.add('is-menu-pinned');
      }

      htmlEl.classList.add('header-2-menu-open');
      document.body.style.top = `-${lockedScrollY}px`;
      syncMenuOffset(root);
      requestAnimationFrame(() => {
        syncMenuOffset(root);
        syncHeader2Scheme();
      });
    } else {
      const y = lockedScrollY;

      htmlEl.classList.add('header-2-restoring-scroll');
      htmlEl.classList.remove('header-2-menu-open');
      document.body.style.top = '';
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });

      if (section) {
        section.classList.remove('is-menu-pinned');
        section.style.removeProperty('--header-2-pin-top');
      }

      requestAnimationFrame(() => {
        htmlEl.classList.remove('header-2-restoring-scroll');
        syncHeader2Scheme();
      });

      resetSubmenu(root);
    }
  };

  document.addEventListener('click', (event) => {
    const menuToggle = event.target.closest('[data-header-2-menu-toggle]');
    if (menuToggle) {
      const root = menuToggle.closest('[data-header-2]');
      setMenuOpen(root, !root.classList.contains('is-menu-open'));
      return;
    }

    const backdrop = event.target.closest('[data-header-2-backdrop]');
    if (backdrop) {
      setMenuOpen(backdrop.closest('[data-header-2]'), false);
      return;
    }

    const accordionToggle = event.target.closest('[data-header-2-accordion-toggle]');
    if (accordionToggle) {
      const submenu = accordionToggle.closest('[data-header-2-submenu]');
      if (!submenu) return;

      const listItem = submenu.closest('li');
      const parentList = listItem ? listItem.parentElement : null;

      if (parentList) {
        for (const sibling of parentList.children) {
          const other = sibling.querySelector(':scope > [data-header-2-submenu]');
          if (!other || other === submenu || !other.classList.contains('is-open')) continue;

          other.classList.remove('is-open');
          for (const nested of other.querySelectorAll('[data-header-2-submenu].is-open')) {
            nested.classList.remove('is-open');
          }
          for (const button of other.querySelectorAll('[data-header-2-accordion-toggle]')) {
            button.setAttribute('aria-expanded', 'false');
          }
        }
      }

      const expanded = accordionToggle.getAttribute('aria-expanded') === 'true';
      submenu.classList.toggle('is-open', !expanded);
      accordionToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');

      if (expanded) {
        for (const nested of submenu.querySelectorAll('[data-header-2-submenu].is-open')) {
          nested.classList.remove('is-open');
        }
        for (const button of submenu.querySelectorAll('[data-header-2-accordion-toggle]')) {
          button.setAttribute('aria-expanded', 'false');
        }
      }

      return;
    }

    const openSubmenu = event.target.closest('[data-header-2-submenu-open]');
    if (openSubmenu) {
      const root = openSubmenu.closest('[data-header-2]');
      const targetId = openSubmenu.getAttribute('data-pane-target');
      if (root && targetId) activatePane(root, targetId);
      return;
    }

    const back = event.target.closest('[data-header-2-submenu-back]');
    if (back) {
      const pane = back.closest('[data-pane]');
      const root = back.closest('[data-header-2]');
      const parentId = pane ? pane.getAttribute('data-pane-parent') || 'root' : 'root';
      activatePane(root, parentId);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    for (const root of document.querySelectorAll('[data-header-2].is-menu-open')) {
      setMenuOpen(root, false);
    }
  });

  const initHeader2Sticky = () => {
    const roots = document.querySelectorAll('[data-header-2][data-header-2-sticky="scroll-up"]');
    if (!roots.length) return;

    let lastScrollY = window.scrollY;
    let ticking = false;
    let upwardPx = 0;

    const revealThreshold = () => Math.max(24, Math.round(window.innerHeight * 0.05));

    const updateSticky = () => {
      ticking = false;

      if (htmlEl.classList.contains('header-2-menu-open')) return;

      const scrollY = Math.max(0, window.scrollY);
      const delta = lastScrollY - scrollY;
      lastScrollY = scrollY;

      for (const root of roots) {
        if (root.classList.contains('is-menu-open')) {
          root.classList.add('is-sticky-active');
          root.classList.remove('is-header-hidden');
          upwardPx = 0;
          continue;
        }

        if (scrollY <= 8) {
          root.classList.remove('is-sticky-active', 'is-header-hidden');
          upwardPx = 0;
          continue;
        }

        if (delta > 0) {
          if (root.classList.contains('is-header-hidden')) {
            upwardPx += delta;

            if (upwardPx >= revealThreshold()) {
              root.classList.add('is-sticky-active');
              root.classList.remove('is-header-hidden');
              upwardPx = 0;
            }
          } else {
            root.classList.add('is-sticky-active');
            root.classList.remove('is-header-hidden');
            upwardPx = 0;
          }
        } else if (delta < 0) {
          root.classList.add('is-header-hidden');
          upwardPx = 0;
        }
      }
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateSticky);
        }
      },
      { passive: true }
    );
  };

  initHeader2Sticky();
  syncAllHeader2Offsets();
  syncHeader2Scheme();

  const initHeader2KanCards = () => {
    const wraps = document.querySelectorAll('.header-2-kan__cards-wrap');

    for (const wrap of wraps) {
      if (wrap.dataset.header2KanBound === 'true') continue;

      const scroller = wrap.querySelector('[data-header-2-kan-scroller]');
      const prev = wrap.querySelector('[data-header-2-kan-prev]');
      const next = wrap.querySelector('[data-header-2-kan-next]');
      if (!scroller || !prev || !next) continue;

      wrap.dataset.header2KanBound = 'true';

      const updateNav = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const canScroll = maxScroll > 4;
        prev.hidden = !canScroll || scroller.scrollLeft <= 4;
        next.hidden = !canScroll || scroller.scrollLeft >= maxScroll - 4;
      };

      const scrollByCard = (direction) => {
        const card = scroller.querySelector('.header-2-kan__card');
        const styles = getComputedStyle(scroller);
        const gap = parseFloat(styles.columnGap || styles.gap) || 12;
        const amount = ((card && card.getBoundingClientRect().width) || scroller.clientWidth / 3) + gap;
        scroller.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      prev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollByCard(-1);
      });
      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollByCard(1);
      });
      scroller.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }
  };

  initHeader2KanCards();

  window.addEventListener(
    'scroll',
    () => {
      requestAnimationFrame(syncHeader2Scheme);
    },
    { passive: true }
  );

  for (const root of document.querySelectorAll('[data-header-2][data-header-2-transparent="true"]')) {
    root.addEventListener('mouseover', syncHeader2Scheme);
    root.addEventListener('mouseout', syncHeader2Scheme);
    root.addEventListener('focusin', syncHeader2Scheme);
    root.addEventListener('focusout', syncHeader2Scheme);
  }

  window.addEventListener('resize', syncAllHeader2Offsets, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncAllHeader2Offsets, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igf-banner-360"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pauseBannerMotion(root) {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.igf-banner-360--motion .igf-banner-360__diagram').forEach(function (diagram) {
        if (diagram.pauseAnimations) diagram.pauseAnimations();
      });
    }

    pauseBannerMotion(document);

    document.addEventListener('shopify:section:load', function (event) {
      pauseBannerMotion(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igf-technical-slideshow"] && !Shopify.designMode) return;
  try {
    
  class IgfTsTechniques extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-igf-ts-technique]'));
      if (this.items.length < 2) return;

      this.mqDesktop = window.matchMedia('(min-width: 750px)');
      this.mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.timer = null;
      this.boundSync = () => this.sync();

      this.mqDesktop.addEventListener('change', this.boundSync);
      this.mqReduce.addEventListener('change', this.boundSync);
      this.sync();
    }

    disconnectedCallback() {
      this.stop();
      if (this.mqDesktop) this.mqDesktop.removeEventListener('change', this.boundSync);
      if (this.mqReduce) this.mqReduce.removeEventListener('change', this.boundSync);
    }

    sync() {
      const rotate = this.hasAttribute('data-rotate-mobile');
      const desktop = this.mqDesktop.matches;
      const reduce = this.mqReduce.matches;

      if (!rotate || desktop || reduce) {
        this.stop();
        this.resetStatic();
        return;
      }

      this.prepareRotator();
      this.start();
    }

    resetStatic() {
      this.style.removeProperty('--igf-ts-tech-height');
      for (const item of this.items) {
        item.classList.remove('is-active', 'is-enter', 'is-exit');
        item.hidden = false;
      }
    }

    prepareRotator() {
      for (const item of this.items) {
        item.classList.remove('is-enter', 'is-exit');
        item.classList.toggle('is-active', item === this.items[this.index]);
      }
      this.updateHeight();
    }

    updateHeight() {
      let maxHeight = 0;
      const active = this.items[this.index];

      for (const item of this.items) {
        const prevClass = item.className;
        item.classList.add('is-active');
        item.classList.remove('is-enter', 'is-exit');
        maxHeight = Math.max(maxHeight, item.offsetHeight || 0);
        item.className = prevClass;
      }

      if (active) {
        active.classList.add('is-active');
        active.classList.remove('is-enter', 'is-exit');
      }

      if (maxHeight > 0) {
        this.style.setProperty('--igf-ts-tech-height', `${maxHeight}px`);
      }
    }

    start() {
      this.stop();
      const interval = Number(this.getAttribute('data-interval') || 3000);
      this.timer = window.setInterval(() => this.next(), interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      if (this.items.length < 2) return;

      const current = this.items[this.index];
      const nextIndex = (this.index + 1) % this.items.length;
      const next = this.items[nextIndex];

      current.classList.remove('is-active', 'is-enter');
      current.classList.add('is-exit');
      next.classList.remove('is-exit');
      next.classList.add('is-active', 'is-enter');

      this.index = nextIndex;
      /* altura já reservada pelo maior item — não reajustar a cada troca */

      window.setTimeout(() => {
        current.classList.remove('is-exit');
      }, 550);
    }
  }

  if (!customElements.get('igf-ts-techniques')) {
    customElements.define('igf-ts-techniques', IgfTsTechniques);
  }

  class IgfTsMetrics extends HTMLElement {
    connectedCallback() {
      this.pairs = Array.from(this.querySelectorAll('[data-igf-ts-pair]')).filter(
        (pair) => pair.querySelector('.igf-ts__metric')
      );
      if (this.pairs.length < 2) {
        if (this.pairs[0]) this.pairs[0].classList.add('is-active');
        return;
      }

      this.mqDesktop = window.matchMedia('(min-width: 750px)');
      this.mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = Math.max(
        0,
        this.pairs.findIndex((pair) => pair.classList.contains('is-active'))
      );
      if (this.index < 0) this.index = 0;
      this.timer = null;
      this.busy = false;
      this.boundSync = () => this.sync();
      this.mqDesktop.addEventListener('change', this.boundSync);
      this.mqReduce.addEventListener('change', this.boundSync);
      this.sync();
    }

    disconnectedCallback() {
      this.stop();
      if (this.mqDesktop) this.mqDesktop.removeEventListener('change', this.boundSync);
      if (this.mqReduce) this.mqReduce.removeEventListener('change', this.boundSync);
    }

    sync() {
      const rotate = this.hasAttribute('data-rotate-mobile');
      if (!rotate || this.mqDesktop.matches || this.mqReduce.matches) {
        this.stop();
        this.showAllStatic();
        return;
      }

      this.prepareRotator();
      this.start();
    }

    showAllStatic() {
      this.removeAttribute('data-ready');
      this.style.removeProperty('--igf-ts-metrics-height');
      for (const pair of this.pairs) {
        pair.classList.add('is-active');
      }
    }

    prepareRotator() {
      for (const pair of this.pairs) {
        pair.classList.toggle('is-active', pair === this.pairs[this.index]);
      }
      this.updateHeight();
      this.setAttribute('data-ready', '');
    }

    updateHeight() {
      let maxHeight = 0;

      for (const pair of this.pairs) {
        const wasActive = pair.classList.contains('is-active');
        const prevVisibility = pair.style.visibility;
        const prevPosition = pair.style.position;
        const prevOpacity = pair.style.opacity;

        pair.classList.add('is-active');
        pair.style.visibility = 'hidden';
        pair.style.position = 'absolute';
        pair.style.opacity = '1';
        pair.style.insetInline = '0';
        pair.style.top = '0';
        pair.style.width = '100%';
        pair.style.pointerEvents = 'none';

        maxHeight = Math.max(maxHeight, pair.offsetHeight || 0);

        if (!wasActive) pair.classList.remove('is-active');
        pair.style.visibility = prevVisibility;
        pair.style.position = prevPosition;
        pair.style.opacity = prevOpacity;
        pair.style.removeProperty('inset-inline');
        pair.style.removeProperty('top');
        pair.style.removeProperty('width');
        pair.style.removeProperty('pointer-events');
      }

      this.pairs[this.index].classList.add('is-active');
      if (maxHeight > 0) {
        this.style.setProperty('--igf-ts-metrics-height', `${maxHeight}px`);
      }
    }

    start() {
      this.stop();
      const interval = Number(this.getAttribute('data-interval') || 4000);
      this.timer = window.setInterval(() => this.next(), interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      if (this.busy || this.pairs.length < 2) return;
      this.busy = true;

      const current = this.pairs[this.index];
      const nextIndex = (this.index + 1) % this.pairs.length;
      const next = this.pairs[nextIndex];

      this.style.setProperty(
        '--igf-ts-metrics-height',
        `${Math.max(current.offsetHeight, next.offsetHeight)}px`
      );

      /* Troca sem opacity no par — blur do ::before permanece estável */
      current.classList.remove('is-active');
      next.classList.add('is-active');
      this.index = nextIndex;

      window.setTimeout(() => {
        this.busy = false;
      }, 360);
    }
  }

  if (!customElements.get('igf-ts-metrics')) {
    customElements.define('igf-ts-metrics', IgfTsMetrics);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MAX_ITEMS = 80;
    const HOVER_RAMP_MS = 2000;
    const tickerState = new WeakMap();

    const easeSmooth = (t) => t * t * (3 - 2 * t);

    const animatePlaybackRate = ({ animation, from, to, duration, onUpdate, onComplete }) => {
      const startTime = performance.now();
      let cancelled = false;
      let currentValue = from;

      const tick = (now) => {
        if (cancelled) return;

        const progress = Math.min((now - startTime) / duration, 1);
        currentValue = from + (to - from) * easeSmooth(progress);
        animation.updatePlaybackRate(currentValue);
        onUpdate?.(currentValue);

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          onComplete?.();
        }
      };

      requestAnimationFrame(tick);

      return {
        get current() {
          return currentValue;
        },
        cancel() {
          cancelled = true;
        },
      };
    };

    const getTrackAnimation = (track) => {
      const animations = track.getAnimations?.() || [];
      return animations.find((animation) => animation instanceof CSSAnimation) || animations[0] || null;
    };

    const rampPlayback = (ticker, toRate) => {
      const state = tickerState.get(ticker);
      if (!state?.track) return;

      const animation = getTrackAnimation(state.track);
      if (!animation) return;

      state.ramp?.cancel();
      const from = state.ramp?.current ?? animation.playbackRate ?? (toRate < 1 ? 1 : 0);

      state.ramp = animatePlaybackRate({
        animation,
        from,
        to: toRate,
        duration: HOVER_RAMP_MS,
        onComplete: () => {
          state.ramp = null;
        },
      });
    };

    const bindHoverRamp = (ticker) => {
      if (ticker.dataset.jvBmHoverBound === 'true') return;

      ticker.dataset.jvBmHoverBound = 'true';

      ticker.addEventListener('pointerenter', () => rampPlayback(ticker, 0));
      ticker.addEventListener('pointerleave', () => rampPlayback(ticker, 1));
    };

    const prepareClone = (group) => {
      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-jv-bm-clone', '');
      clone.removeAttribute('data-jv-bm-group');

      for (const link of clone.querySelectorAll('a')) {
        link.setAttribute('tabindex', '-1');
      }

      for (const img of clone.querySelectorAll('img')) {
        img.alt = '';
      }

      return clone;
    };

    const fillGroup = (group, viewport) => {
      const seeds = Array.from(group.children);

      if (!seeds.length) return;

      let guard = 0;

      while (group.scrollWidth < viewport.clientWidth && group.children.length < MAX_ITEMS && guard < 40) {
        for (const seed of seeds) {
          const node = seed.cloneNode(true);
          node.removeAttribute('data-shopify-editor-block');

          for (const el of node.querySelectorAll('[data-shopify-editor-block]')) {
            el.removeAttribute('data-shopify-editor-block');
          }

          for (const link of node.querySelectorAll('a')) {
            link.setAttribute('tabindex', '-1');
          }

          for (const img of node.querySelectorAll('img')) {
            img.alt = '';
          }

          group.appendChild(node);

          if (group.scrollWidth >= viewport.clientWidth || group.children.length >= MAX_ITEMS) break;
        }

        guard += 1;
      }
    };

    const waitForImages = (root) => {
      const images = Array.from(root.querySelectorAll('img'));

      return Promise.all(
        images.map((img) => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();

          return new Promise((resolve) => {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          });
        })
      );
    };

    const setupTicker = async (ticker) => {
      const viewport = ticker.querySelector('.jv-brand-marquee__viewport');
      const track = ticker.querySelector('.jv-brand-marquee__track');
      const group = ticker.querySelector('[data-jv-bm-group]');

      if (!viewport || !track || !group) return;

      const prev = tickerState.get(ticker);
      prev?.ramp?.cancel();

      track.querySelectorAll('[data-jv-bm-clone]').forEach((node) => node.remove());

      if (!group.dataset.jvBmSeedCount) {
        group.dataset.jvBmSeedCount = String(group.children.length);
      }

      const seedCount = Number(group.dataset.jvBmSeedCount) || group.children.length;

      while (group.children.length > seedCount) {
        group.lastElementChild?.remove();
      }

      await waitForImages(group);
      fillGroup(group, viewport);
      track.appendChild(prepareClone(group));

      track.style.animation = 'none';
      void track.offsetWidth;
      track.style.animation = '';

      tickerState.set(ticker, { track, ramp: null });
      bindHoverRamp(ticker);
    };

    const initAll = () => {
      document.querySelectorAll('[data-jv-brand-marquee]').forEach(setupTicker);
    };

    let resizeTimer;

    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initAll, 200);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    window.addEventListener('resize', onResize, { passive: true });

    document.addEventListener('shopify:section:load', (event) => {
      const ticker = event.target.querySelector?.('[data-jv-brand-marquee]');
      if (ticker) {
        ticker.dataset.jvBmHoverBound = '';
        setupTicker(ticker);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-featured-collections-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '[data-testid="featured-collections-tabs"]';

    function scrollTabIntoView(tab, scroller) {
      if (!tab || !scroller) return;
      const tabLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const scrollerWidth = scroller.clientWidth;
      const targetScroll = tabLeft - (scrollerWidth / 2) + (tabWidth / 2);
      scroller.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }

    function triggerCascade(section, panel) {
      if (section.dataset.cascadeEnabled !== 'true' || !panel) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const items = panel.querySelectorAll('.jv-fc-tabs__product-item');
      const initialDelay = Number(section.dataset.cascadeInitialDelay || 0);
      const stagger = Number(section.dataset.cascadeStagger || 80);

      items.forEach((item) => {
        item.classList.remove('jv-fc-cascade-visible');
        item.style.animationDelay = '';
        if (prefersReducedMotion) {
          item.style.opacity = '1';
          return;
        }
        item.style.opacity = '0';
      });

      if (prefersReducedMotion) return;

      items.forEach((item, index) => {
        const delay = initialDelay + index * stagger;
        item.style.animationDelay = delay + 'ms';
        window.setTimeout(() => {
          item.classList.add('jv-fc-cascade-visible');
        }, 10);
      });
    }

    function initFeaturedCollectionsTabs(section) {
      if (!section || section.dataset.fcTabsInit === 'true') return;
      section.dataset.fcTabsInit = 'true';

      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      const bannerPanels = Array.from(section.querySelectorAll('.jv-fc-tabs__banner-panel'));
      const productPanels = Array.from(section.querySelectorAll('.jv-fc-tabs__products-panel'));
      const scroller = section.querySelector('.jv-fc-tabs__tab-scroller');

      if (!tabs.length) return;

      function activateTab(selectedTab) {
        const targetId = selectedTab.dataset.tab;

        tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
        });

        bannerPanels.forEach((panel) => {
          const isTarget = panel.dataset.panel === targetId;
          panel.classList.toggle('is-active', isTarget);
          panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
        });

        productPanels.forEach((panel) => {
          const isTarget = panel.dataset.panel === targetId;
          panel.classList.toggle('is-active', isTarget);
          panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
          if (isTarget) {
            triggerCascade(section, panel);
          }
        });

        scrollTabIntoView(selectedTab, scroller);
      }

      function handleKeyboard(event) {
        const currentIndex = tabs.indexOf(event.currentTarget);
        if (currentIndex < 0) return;

        let newIndex = currentIndex;

        switch (event.key) {
          case 'ArrowLeft':
            event.preventDefault();
            newIndex = currentIndex - 1 < 0 ? tabs.length - 1 : currentIndex - 1;
            break;
          case 'ArrowRight':
            event.preventDefault();
            newIndex = currentIndex + 1 >= tabs.length ? 0 : currentIndex + 1;
            break;
          case 'Home':
            event.preventDefault();
            newIndex = 0;
            break;
          case 'End':
            event.preventDefault();
            newIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        tabs[newIndex].focus();
        activateTab(tabs[newIndex]);
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          activateTab(tab);
        });
        tab.addEventListener('keydown', handleKeyboard);
      });

      const activePanel = section.querySelector('.jv-fc-tabs__products-panel.is-active');
      triggerCascade(section, activePanel);
    }

    function initAll() {
      document.querySelectorAll(SECTION_SELECTOR).forEach(initFeaturedCollectionsTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector(SECTION_SELECTOR);
      if (section) {
        section.dataset.fcTabsInit = 'false';
        initFeaturedCollectionsTabs(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-mobile-menu"] && !Shopify.designMode) return;
  try {
    
  class JvMobileMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[ref="trigger"]');
      this.dialog = this.querySelector('[ref="dialog"]');
      this.closeBtn = this.querySelector('[ref="close"]');
      this.accountBtn = this.querySelector('[data-jv-mm-account]');
      this.replaceHeader = this.dataset.replaceHeader === 'true';
      this.animMs = Number(this.dataset.animMs || 380);
      this.lastFocused = null;
      this.isClosing = false;
      this.headerSummary = null;
      this.headerDetails = null;

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onDialogCancel = this.onDialogCancel.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onAccountClick = this.onAccountClick.bind(this);
      this.onHeaderMenuClick = this.onHeaderMenuClick.bind(this);
      this.onHeaderToggle = this.onHeaderToggle.bind(this);

      if (this.trigger) {
        this.trigger.addEventListener('click', this.onTriggerClick);
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.onCloseClick);
      }
      if (this.dialog) {
        this.dialog.addEventListener('cancel', this.onDialogCancel);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.closeMenu();
          }
        });
      }
      if (this.accountBtn) {
        this.accountBtn.addEventListener('click', this.onAccountClick);
      }

      if (this.replaceHeader) {
        this.bindHeaderMenu();
      }
    }

    disconnectedCallback() {
      if (this.trigger) {
        this.trigger.removeEventListener('click', this.onTriggerClick);
      }
      if (this.closeBtn) {
        this.closeBtn.removeEventListener('click', this.onCloseClick);
      }
      if (this.dialog) {
        this.dialog.removeEventListener('cancel', this.onDialogCancel);
      }
      if (this.accountBtn) {
        this.accountBtn.removeEventListener('click', this.onAccountClick);
      }
      if (this.headerSummary) {
        this.headerSummary.removeEventListener('click', this.onHeaderMenuClick, true);
      }
      if (this.headerDetails) {
        this.headerDetails.removeEventListener('toggle', this.onHeaderToggle);
      }
      document.removeEventListener('keydown', this.onKeydown);
      document.documentElement.classList.remove('jv-mm-replacing', 'jv-mm-open');
    }

    bindHeaderMenu() {
      const find = () => {
        this.headerSummary =
          document.querySelector('.header__drawer.desktop\\:hidden summary.header__icon--menu') ||
          document.querySelector('.header__drawer--mobile summary.header__icon--menu') ||
          document.querySelector('.header__drawer.desktop\\:hidden summary') ||
          document.querySelector('header-drawer.header__drawer--mobile summary');

        if (!this.headerSummary) return false;

        this.headerDetails = this.headerSummary.closest('details');
        this.headerSummary.addEventListener('click', this.onHeaderMenuClick, true);
        if (this.headerDetails) {
          this.headerDetails.addEventListener('toggle', this.onHeaderToggle);
          this.headerDetails.open = false;
        }
        document.documentElement.classList.add('jv-mm-replacing');
        return true;
      };

      if (!find()) {
        requestAnimationFrame(() => find());
        setTimeout(find, 300);
      }
    }

    onHeaderMenuClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.headerDetails) {
        this.headerDetails.open = false;
      }
      this.openMenu();
    }

    onHeaderToggle() {
      if (this.headerDetails && this.headerDetails.open) {
        this.headerDetails.open = false;
      }
    }

    onTriggerClick(event) {
      event.preventDefault();
      this.openMenu();
    }

    onCloseClick(event) {
      event.preventDefault();
      this.closeMenu();
    }

    onDialogCancel(event) {
      event.preventDefault();
      this.closeMenu();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.dialog && this.dialog.open) {
        event.preventDefault();
        this.closeMenu();
      }
    }

    openMenu() {
      if (!this.dialog || this.isClosing) return;
      this.lastFocused = document.activeElement;
      this.dialog.classList.remove('is-closing', 'is-open');

      if (typeof this.dialog.showModal === 'function') {
        if (!this.dialog.open) {
          this.dialog.showModal();
        }
      } else {
        this.dialog.setAttribute('open', '');
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.dialog.classList.add('is-open');
        });
      });

      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'true');
      }
      if (this.headerSummary) {
        this.headerSummary.setAttribute('aria-expanded', 'true');
      }
      document.addEventListener('keydown', this.onKeydown);
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('jv-mm-open');
      if (this.closeBtn) {
        this.closeBtn.focus();
      }
    }

    closeMenu() {
      if (!this.dialog || this.isClosing || !this.dialog.open) return;
      this.isClosing = true;
      this.dialog.classList.add('is-closing');
      this.dialog.classList.remove('is-open');

      const finish = () => {
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
        this.dialog.classList.remove('is-closing');
        this.isClosing = false;
        if (this.trigger) {
          this.trigger.setAttribute('aria-expanded', 'false');
        }
        if (this.headerSummary) {
          this.headerSummary.setAttribute('aria-expanded', 'false');
        }
        document.removeEventListener('keydown', this.onKeydown);
        document.documentElement.style.overflow = '';
        document.documentElement.classList.remove('jv-mm-open');
        if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
          this.lastFocused.focus();
        }
      };

      const reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) {
        finish();
        return;
      }

      let done = false;
      const onEnd = (event) => {
        if (!event.target || !event.target.classList || !event.target.classList.contains('jv-mm__shell')) {
          return;
        }
        if (event.propertyName && event.propertyName !== 'transform') return;
        if (done) return;
        done = true;
        this.dialog.removeEventListener('transitionend', onEnd);
        finish();
      };
      this.dialog.addEventListener('transitionend', onEnd);
      setTimeout(() => {
        if (done) return;
        done = true;
        this.dialog.removeEventListener('transitionend', onEnd);
        finish();
      }, this.animMs + 80);
    }

    onAccountClick(event) {
      event.preventDefault();
      this.closeMenu();
      const openAccount = () => {
        const accountDrawer = document.querySelector('dialog-component.account-drawer');
        if (accountDrawer && typeof accountDrawer.showDialog === 'function') {
          accountDrawer.showDialog();
          return true;
        }
        return false;
      };
      setTimeout(() => {
        if (!openAccount()) {
          const fallback = this.accountBtn.getAttribute('data-account-fallback') || '/account/login';
          window.location.href = fallback;
        }
      }, Math.min(this.animMs, 200));
    }
  }

  if (!customElements.get('jv-mobile-menu')) {
    customElements.define('jv-mobile-menu', JvMobileMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-product-list-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-testid="product-list-tabs"]');
    
    sections.forEach(section => {
      const tabs = section.querySelectorAll('[role="tab"]');
      const panels = section.querySelectorAll('[role="tabpanel"]');
      
      const scrollContainer = section.querySelector('.product-tabs-scroll');
      const mobileTabsQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      function scrollTabIntoView(tab) {
        if (!scrollContainer || !mobileTabsQuery.matches) return;

        const tabLeft = tab.offsetLeft;
        const tabWidth = tab.offsetWidth;
        const containerWidth = scrollContainer.clientWidth;
        const targetScroll = tabLeft - containerWidth / 2 + tabWidth / 2;

        scrollContainer.scrollTo({
          left: Math.max(0, targetScroll),
          behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
        });
      }

      function refreshPanelCarousel(panel) {
        if (!panel) return;

        requestAnimationFrame(() => {
          const scroller = panel.querySelector('slideshow-slides');

          if (scroller) {
            scroller.scrollLeft = 0;
          }

          window.dispatchEvent(new Event('resize'));
        });
      }

      function switchTab(selectedTab) {
        const targetPanel = selectedTab.getAttribute('aria-controls');
        let activatedPanel = null;

        tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', isSelected);
          tab.classList.toggle('active', isSelected);
        });

        panels.forEach((panel) => {
          const isTarget = panel.id === targetPanel;

          if (isTarget) {
            panel.classList.add('active');
            activatedPanel = panel;
          } else {
            panel.classList.remove('active');
          }
        });

        refreshPanelCarousel(activatedPanel);
        scrollTabIntoView(selectedTab);
      }
      
      function handleKeyboard(e) {
        const tabsArray = Array.from(tabs);
        const currentIndex = tabsArray.indexOf(e.currentTarget);
        let newIndex;

        switch(e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            newIndex = currentIndex - 1;
            if (newIndex < 0) newIndex = tabsArray.length - 1;
            tabsArray[newIndex].focus();
            switchTab(tabsArray[newIndex]);
            break;
          case 'ArrowRight':
            e.preventDefault();
            newIndex = currentIndex + 1;
            if (newIndex >= tabsArray.length) newIndex = 0;
            tabsArray[newIndex].focus();
            switchTab(tabsArray[newIndex]);
            break;
          case 'Home':
            e.preventDefault();
            tabsArray[0].focus();
            switchTab(tabsArray[0]);
            break;
          case 'End':
            e.preventDefault();
            tabsArray[tabsArray.length - 1].focus();
            switchTab(tabsArray[tabsArray.length - 1]);
            break;
        }
      }
      
      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          switchTab(e.currentTarget);
        });
        tab.addEventListener('keydown', handleKeyboard);
      });

      const initialActiveTab = section.querySelector('[role="tab"].active');
      if (initialActiveTab) {
        scrollTabIntoView(initialActiveTab);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav-2"] && !Shopify.designMode) return;
  try {
    
  class MobileBottomNav extends HTMLElement {
    connectedCallback() {
      this.lastScrollY = window.scrollY;
      this.scrollThreshold = Number(this.dataset.scrollThreshold) || 12;
      this.hideOnScroll = this.dataset.hideOnScroll === 'true';
      this.hideWhenStickyVisible = this.dataset.hideWhenStickyVisible === 'true';
      this.stickySelector = (this.dataset.stickyOverlaySelector || '').trim();
      this.ticking = false;
      this.enablePageTransition = this.dataset.enablePageTransition === 'true';

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (this.enablePageTransition) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.classList.add('is-entered');
          });
        });
      }

      this.updateState();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    handleScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateState();
        this.ticking = false;
      });
    }

    handleResize() {
      this.updateState();
    }

    updateState() {
      const currentY = window.scrollY;
      const diff = currentY - this.lastScrollY;

      if (this.hideWhenStickyVisible && this.stickySelector) {
        const stickyVisible = Boolean(document.querySelector(this.stickySelector));
        if (stickyVisible) {
          this.classList.add('is-covered-by-sticky');
        } else {
          this.classList.remove('is-covered-by-sticky');
        }
      } else {
        this.classList.remove('is-covered-by-sticky');
      }

      if (!this.hideOnScroll) {
        this.classList.remove('is-hidden');
        this.lastScrollY = currentY;
        return;
      }

      if (Math.abs(diff) < this.scrollThreshold) {
        this.lastScrollY = currentY;
        return;
      }

      if (diff > 0 && currentY > 20) {
        this.classList.add('is-hidden');
      } else if (diff < 0) {
        this.classList.remove('is-hidden');
      }

      this.lastScrollY = currentY;
    }
  }

  if (!customElements.get('mobile-bottom-nav')) {
    customElements.define('mobile-bottom-nav', MobileBottomNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav-glass"] && !Shopify.designMode) return;
  try {
    
  class MobileBottomNavGlass extends HTMLElement {
    connectedCallback() {
      this.lastScrollY = window.scrollY;
      this.scrollThreshold = Number(this.dataset.scrollThreshold) || 12;
      this.hideOnScroll = this.dataset.hideOnScroll === 'true';
      this.ticking = false;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleActionClick = this.handleActionClick.bind(this);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.addEventListener('click', this.handleActionClick);
      this.updateState();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.removeEventListener('click', this.handleActionClick);
    }

    handleActionClick(event) {
      const trigger = event.target.closest('[data-mbng-action]');
      if (!trigger || !this.contains(trigger)) return;

      const action = trigger.dataset.mbngAction;
      const fallback = trigger.dataset.mbngFallback || '';

      if (!action || action === 'link') return;

      event.preventDefault();

      const opened = this.openAction(action);
      if (!opened && fallback) {
        window.location.assign(fallback);
      }
    }

    openAction(action) {
      switch (action) {
        case 'search_modal': {
          const searchModal = document.getElementById('search-modal');
          if (searchModal && typeof searchModal.showDialog === 'function') {
            searchModal.showDialog();
            return true;
          }
          return false;
        }
        case 'cart_drawer': {
          const cartDrawer =
            document.querySelector('cart-drawer-component.cart-drawer-section') ||
            document.querySelector('cart-drawer-component');
          if (!cartDrawer) return false;

          const openCart = () => {
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
              return true;
            }
            if (typeof cartDrawer.showDialog === 'function') {
              cartDrawer.showDialog();
              return true;
            }
            return false;
          };

          if (customElements.get('cart-drawer-component')) {
            return openCart();
          }

          customElements.whenDefined('cart-drawer-component').then(openCart);
          return true;
        }
        case 'account_drawer': {
          const accountDrawer = document.querySelector('dialog-component.account-drawer');
          if (accountDrawer && typeof accountDrawer.showDialog === 'function') {
            accountDrawer.showDialog();
            return true;
          }
          return false;
        }
        default:
          return false;
      }
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateState();
        this.ticking = false;
      });
    }

    handleResize() {
      this.updateState();
    }

    updateState() {
      const currentY = window.scrollY;
      const diff = currentY - this.lastScrollY;
      const stickyCartVisible = Boolean(document.querySelector('.product-sticky-cart.is-visible'));

      this.classList.toggle('is-covered-by-sticky', stickyCartVisible);

      if (!this.hideOnScroll) {
        this.classList.remove('is-hidden');
        this.lastScrollY = currentY;
        return;
      }

      if (Math.abs(diff) < this.scrollThreshold) {
        this.lastScrollY = currentY;
        return;
      }

      if (diff > 0 && currentY > 20) {
        this.classList.add('is-hidden');
      } else if (diff < 0) {
        this.classList.remove('is-hidden');
      }

      this.lastScrollY = currentY;
    }
  }

  if (!customElements.get('mobile-bottom-nav-glass')) {
    customElements.define('mobile-bottom-nav-glass', MobileBottomNavGlass);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    
  class MobileBottomNav extends HTMLElement {
    connectedCallback() {
      this.isHidden = false;
      this.lastScrollY = window.scrollY;
      this.scrollThreshold = Number(this.dataset.scrollThreshold) || 12;
      this.hideOnScroll = this.dataset.hideOnScroll === 'true';
      this.hideWhenStickyVisible = true;
      this.ticking = false;
      this.enablePageTransition = this.dataset.enablePageTransition === 'true';

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (this.enablePageTransition) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.classList.add('is-entered');
          });
        });
      }

      this.updateState();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    handleScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateState();
        this.ticking = false;
      });
    }

    handleResize() {
      this.updateState();
    }

    updateState() {
      const currentY = window.scrollY;
      const diff = currentY - this.lastScrollY;
      const stickyCartVisible = Boolean(document.querySelector('.product-sticky-cart.is-visible'));

      if (this.hideWhenStickyVisible && stickyCartVisible) {
        this.classList.add('is-covered-by-sticky');
      } else {
        this.classList.remove('is-covered-by-sticky');
      }

      if (!this.hideOnScroll) {
        this.classList.remove('is-hidden');
        this.lastScrollY = currentY;
        return;
      }

      if (Math.abs(diff) < this.scrollThreshold) {
        this.lastScrollY = currentY;
        return;
      }

      if (diff > 0 && currentY > 20) {
        this.classList.add('is-hidden');
      } else if (diff < 0) {
        this.classList.remove('is-hidden');
      }

      this.lastScrollY = currentY;
    }
  }

  if (!customElements.get('mobile-bottom-nav')) {
    customElements.define('mobile-bottom-nav', MobileBottomNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications"] && !Shopify.designMode) return;
  try {
    
    // Tooltip functionality
    document.addEventListener('DOMContentLoaded', function() {
      const infoButtons = document.querySelectorAll('.specification-block__info-button');
      
      infoButtons.forEach(button => {
        const tooltipId = button.dataset.tooltipId;
        const tooltip = document.getElementById(tooltipId);
        
        if (!tooltip) return;
        
        // Toggle tooltip on click
        button.addEventListener('click', function(e) {
          e.stopPropagation();
          
          // Close all other tooltips
          document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(t => {
            if (t !== tooltip) {
              t.setAttribute('hidden', '');
            }
          });
          
          // Toggle this tooltip
          if (tooltip.hasAttribute('hidden')) {
            tooltip.removeAttribute('hidden');
          } else {
            tooltip.setAttribute('hidden', '');
          }
        });
        
        // Hover to show (optional)
        button.addEventListener('mouseenter', function() {
          tooltip.removeAttribute('hidden');
        });
        
        button.addEventListener('mouseleave', function() {
          // Small delay before hiding
          setTimeout(() => {
            if (!tooltip.matches(':hover')) {
              tooltip.setAttribute('hidden', '');
            }
          }, 100);
        });
        
        // Keep tooltip open when hovering over it
        tooltip.addEventListener('mouseenter', function() {
          tooltip.removeAttribute('hidden');
        });
        
        tooltip.addEventListener('mouseleave', function() {
          tooltip.setAttribute('hidden', '');
        });
      });
      
      // Close tooltips when clicking outside
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.specification-block__info-wrapper')) {
          document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(tooltip => {
            tooltip.setAttribute('hidden', '');
          });
        }
      });
      
      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(tooltip => {
            tooltip.setAttribute('hidden', '');
          });
        }
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
